
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.chart-container {min-height: 100%;border-radius: 0.75rem;background-color: var(--cyan-near-lighten-4);padding-top: 0.75rem;padding-bottom: 0.75rem;padding-left: 1rem;padding-right: 1rem
}@media (min-width: 1024px) {.chart-container {padding-left: 1.75rem;padding-right: 1.75rem
  }
}.chart-container idb-heading, .chart-container idb-styled-text {width: 100%
}.chart-container img {margin-bottom: 0px
}.chart-container img {margin-left: -5%
}.chart-container img {width: 100%
}.chart-container .chart-image {margin-top: auto
}.chart-container.draw-preview {display: flex
}.chart-container.draw-preview {flex-direction: column
}@media (min-width: 480px) {.chart-container.draw-preview {max-width: 300px
  }
}.chart-container.draw-preview .chart-heading {margin-bottom: 1rem
}.chart-container.draw-preview .metric-description {margin-bottom: 0.75rem
}.chart-container.draw-graph {display: flex
}.chart-container.draw-graph {flex-direction: column
}.chart-container.draw-graph {gap: 0.5rem
}.chart-container.draw-graph .chart-heading {margin-bottom: 1.75rem
}.chart-container.draw-graph .chart-heading {display: grid
}.chart-container.draw-graph .chart-heading {width: 100%
}.chart-container.draw-graph .chart-heading {grid-template-columns: repeat(1, minmax(0, 1fr))
}@media (min-width: 1024px) {.chart-container.draw-graph .chart-heading {grid-template-columns: 5fr 7fr
  }
}.chart-container.draw-graph .chart-heading .metric {margin-bottom: 1rem
}.chart-container.draw-graph .chart-heading .metric {width: 100%
}.chart-container.draw-graph .chart-heading .description {width: 100%
}.chart-container.draw-graph .chart-graph {margin-top: auto
}.chart-container.draw-graph .chart-graph {display: grid
}.chart-container.draw-graph .chart-graph {width: 100%
}.chart-container.draw-graph .chart-graph {grid-template-columns: repeat(1, minmax(0, 1fr))
}.chart-container.draw-graph .chart-graph {grid-template-rows: auto auto
}.chart-container.draw-graph .chart-graph {gap: 0.5rem
}@media (min-width: 768px) {.chart-container.draw-graph .chart-graph {grid-template-columns: 5fr 7fr
  }
}@media (min-width: 768px) {.chart-container.draw-graph .chart-graph {grid-template-rows: repeat(1, minmax(0, 1fr))
  }
}.chart-container.draw-graph .chart-graph idb-styled-text {min-height: 6rem
}.chart-container.draw-graph .chart-graph .related {grid-column-start: 1
}.chart-container.draw-graph .chart-graph .related {grid-row-start: 2
}.chart-container.draw-graph .chart-graph .related {margin-top: 1.5rem
}.chart-container.draw-graph .chart-graph .related {margin-bottom: 1rem
}.chart-container.draw-graph .chart-graph .related {width: 100%
}@media (min-width: 768px) {.chart-container.draw-graph .chart-graph .related {grid-row-start: 1
  }
}@media (min-width: 768px) {.chart-container.draw-graph .chart-graph .related {margin-top: auto
  }
}.chart-container.draw-graph .chart-graph .related .sdg-list {display: none
}@media (min-width: 640px) {.chart-container.draw-graph .chart-graph .related .sdg-list {display: grid
  }
}.chart-container.draw-graph .chart-graph .graph {grid-row-start: 1
}.chart-container.draw-graph .chart-graph .graph {margin-top: 0px
}.chart-container.draw-graph .chart-graph .graph {height: auto
}.chart-container.draw-graph .chart-graph .graph {width: 100%
}@media (min-width: 768px) {.chart-container.draw-graph .chart-graph .graph {grid-column-start: 2
  }
}@media (min-width: 768px) {.chart-container.draw-graph .chart-graph .graph {margin-top: auto
  }
}.chart-container.draw-graph .chart-graph idb-highcharts {display: block
}.chart-container.draw-graph .chart-graph idb-highcharts {height: 15rem
}.chart-container.draw-graph .chart-graph idb-highcharts {width: 100%
}.chart-container.draw-graph .sdg-list {display: grid
}.chart-container.draw-graph .sdg-list {max-width: 200px
}.chart-container.draw-graph .sdg-list {list-style-type: none
}.chart-container.draw-graph .sdg-list {grid-template-columns: repeat(3, minmax(0, 1fr))
}.chart-container.draw-graph .sdg-list {gap: 0.5rem
}.chart-container.draw-graph .sdg-list {padding: 0px
}.chart-container.draw-graph .sdg-list img {aspect-ratio: 1 / 1
}.chart-container.draw-graph .sdg-list img {width: 100%
}.chart-container.draw-graph .sdg-list img {--tw-translate-x: 5%;transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}.chart-container ::slotted([slot='related']) {margin-bottom: 1rem
}.chart-container ::slotted([slot='related']) {display: none
}@media (min-width: 640px) {.chart-container ::slotted([slot='related']) {display: block
  }
}.chart-container ::slotted([slot='source']) {margin-bottom: 1rem
}.chart-container ::slotted([slot='source']) {margin-top: 0.5rem
}`;